import { render } from "./AbnormalCheck.vue?vue&type=template&id=5a9dedac&scoped=true&ts=true"
import script from "./AbnormalCheck.vue?vue&type=script&lang=ts"
export * from "./AbnormalCheck.vue?vue&type=script&lang=ts"

import "./AbnormalCheck.vue?vue&type=style&index=0&id=5a9dedac&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9dedac"]])

export default __exports__